module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow"
  }, [_vm._v(_vm._s(_vm.registered ? 'Success!' : 'Register'))]), _vm._v(" "), (_vm.errors.any() || _vm.error) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [(_vm.errors.has('fname')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("Please enter your first name")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('lname')) ? _c('p', {
    staticClass: "error wrong_name error-box"
  }, [_vm._v("Please enter your last name")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "error wrong_email error-box"
  }, [_vm._v("Please enter a valid email")]) : _vm._e(), _vm._v(" "), (_vm.errors.has('password')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))]) : _vm._e(), _vm._v(" "), (_vm.errors.has('repeatpassword')) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v("Please repeat password")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error wrong_message error-box"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [(!_vm.registered) ? _c('form', {
    attrs: {
      "name": "formregister"
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.fname),
      expression: "user.fname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "text",
      "name": "fname",
      "maxlength": "25",
      "data-vv-delay": "2000",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.user.fname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.fname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lname),
      expression: "user.lname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "text",
      "name": "lname",
      "maxlength": "50",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": (_vm.user.lname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.lname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "text",
      "name": "email",
      "maxlength": "100",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('min:8|required|confirmed:repeatpassword'),
      expression: "'min:8|required|confirmed:repeatpassword'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "password",
      "name": "password",
      "maxlength": "30",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.confirmPassword),
      expression: "user.confirmPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "contact_form",
    attrs: {
      "type": "password",
      "id": "label_name",
      "name": "repeatpassword",
      "maxlength": "30",
      "data-vv-delay": "2000"
    },
    domProps: {
      "value": (_vm.user.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.confirmPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button submit",
    attrs: {
      "type": "submit",
      "value": "Register",
      "name": "submitButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signup($event)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.registered) ? _c('div', [_vm._v("\n      You have successfully registered. "), _c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Please log in.")])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Already a member? "), _c('router-link', {
    attrs: {
      "to": {
        path: '/login'
      }
    }
  }, [_vm._v("Login in.")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text_form"
  }, [_vm._v("\n        First Name: "), _c('br'), _vm._v("\n        Last Name: "), _c('br'), _vm._v("\n        Email: "), _c('br'), _vm._v("\n        Password: "), _c('br'), _vm._v("\n        Repeat PW:\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e937fdb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Register.vue
// module id = 289
// module chunks = 1